import { render, staticRenderFns } from "./newBoard.vue?vue&type=template&id=11b7af72&scoped=true"
import script from "./newBoard.vue?vue&type=script&lang=js"
export * from "./newBoard.vue?vue&type=script&lang=js"
import style0 from "./newBoard.vue?vue&type=style&index=0&id=11b7af72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7af72",
  null
  
)

export default component.exports